<template>
  <div>
    <NavBarAdmin></NavBarAdmin>
    <div class="card p-1 mt-3 mb-3 w-75 mx-auto border-danger">
      <p>
        <br>
        {{ instruction5 }} <strong><i>indispensable</i></strong> que exista su <strong><i>precio asociado.</i></strong>
        <br> {{ instruction6 }}<router-link class="link1" to="/Admin/ListPrices">Listado de precios</router-link>
        {{ instruction7 }}
      </p>
    </div>
    <button class="btn btn-danger float-end me-5 mb-3">
      <router-link to="/Admin/SheetNew" class="link2">Crear nueva lámina</router-link>
    </button>
    <h4 class="mt-4 mb-3">
      Catálogo de láminas metálicas
    </h4>
    <div class="popup">
      <SheetTypesList v-show="showList" :sendSheetInfo="sheetInfo" @close-list="closeList"></SheetTypesList>
    </div>
    <div>
      <SheetCatalogueTable @sendMainSheetIdForTypes="getSheetIdForTypes" @sendMainSheetIdForEdit="getSheetIdForEdit">
      </SheetCatalogueTable>
    </div>
    <div>
      <EditSheetAndTypes v-show="showEditForm" :sendSheetId="sheetId" @close="closeEditForm"></EditSheetAndTypes>
    </div>
    <FooterAdmin></FooterAdmin>
  </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import SheetCatalogueTable from "@/components/Admin/Sheet/SheetCatalogueComponent.vue";
import SheetTypesList from "@/components/Admin/Sheet/SheetTypesListComponent.vue";
import EditSheetAndTypes from "@/components/Admin/Sheet/EditSheetAndTypesComponent.vue"
export default {
  name: "Sheet Catalogue",
  components: {
    NavBarAdmin,
    SheetCatalogueTable,
    SheetTypesList,
    FooterAdmin,
    EditSheetAndTypes
  },
  data() {
    return {
      instruction5:
        "Tenga en cuenta que antes de de crear cualquier lámina es ",
      instruction6:
        "Revise el ",
      instruction7: ", sí ninguno obedece a sus necesidades cree uno nuevo.",
      showList: false,
      sheets: [],
      sheetId: null,
      sheetInfo: [],
      showEditForm: false,
    };
  },
  methods: {
    getSheetIdForTypes(data) {
      this.sheetInfo = data,
        // console.log(this.sheetInfo);
        this.showList = true;
    },
    closeList() {
      this.showList = false; // Cerrar el componente estableciendo showList en falso
    },
    getSheetIdForEdit(data) {
      this.sheetId = data,
        // console.log(this.sheetId);
        this.showEditForm = true;
    },
    closeEditForm(data) {
      this.showEditForm = data;
    }
  },
};
</script>
<style scoped>
.popup {
  position: fixed;
  top: 50%;
  /* Centrar verticalmente en la mitad de la pantalla */
  left: 50%;
  /* Centrar horizontalmente en la mitad de la pantalla */
  transform: translate(-50%, -50%);
  /* Alinear al centro */
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 999;
  /* Asegurarse de que esté en el frente */
  max-height: 80vh;
  /* Limitar la altura del popup al 80% del alto de la ventana */
  overflow-y: auto;
  /* Habilitar el desplazamiento vertical cuando el contenido es más alto que el popup */
}

.link1 {
  color: #9d0e15;
}
</style>